import React from 'react'
import { Link } from 'react-router-dom'

const Error = props => {
    var code = parseInt(props.code, 10);

    var title,
        message = null,
        redirect,
        buttonText;

    switch (code) {
        case 400:
            title = <span>Bad Request</span>;
            message = <p>
                Your email is associated with a different method of authentication, please try again.
            </p>;
            buttonText = 'Login'
            break;

        case 401:
            title = <span>User Not Authorized</span>;
            message = <p>
                If the error persists and you feel this to be a mistake, please email <strong><span>support</span><span>@</span>invintus.com</strong>
            </p>;
            buttonText = 'Home'
            break;

        case 404:
            title = <span>Page Not Found</span>;
            redirect = document.referrer ? document.referrer : '/admin';
            buttonText = 'Home'
            break;

        case 419:
            title = <span>Session Timed Out</span>;
            buttonText = 'Login';
            break;
        default:
            title = <span>Login Error</span>;
            message = <p>
                If the error persists and you feel this to be a mistake, please email <strong><span>support</span><span>@</span>invintus.com</strong>
            </p>;
            buttonText = 'Login'
            break;

    }

    return (
        <div className="container">
            <div className="invintus__error-wrapper">
                <div className="invintus__error-content">
                    <h3>Error {code}: {title}</h3>
                    {message != null ? <hr/> : null}
                    {message}
                </div>
                <div className="invintus__error-footer">
                    <p className="text-right">
                        <Link to='/' className="btn btn-link">
                            {buttonText}
                        </Link>
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Error;
